export enum PostalAddressOption {
  MainAddress = 'Pre-filled from main address',
  DifferentAddress = 'To a different address',
  LockedBagGpoAddress = 'To a locked bag or GPO',
  StreetAddress = 'To a street address',
}

export enum TermsAndConditions {
  Unspecified = '',
  Accepted = 'accepted',
}

export enum HistoryDetail {
  InsuranceClaimRefused = 'INSURANCECLAIMREFUSED',
  DeniedPurchase = 'INSURANCEDENIED',
  ConvictedBurglary = 'BURGLARY',
  ConvictedCriminalOffence = 'CRIMINALOFFENCE',
  None = 'NONE',
}
